export default __webpack_public_path__ + "static/media/Banners_promos_pasada_Arzebaiyan.cc2f1cf5.webp";